import {
  ReviewQuestionType,
  type ReviewAnswer,
  type ReviewQuestion,
} from '@gokrew/models/performance';
import { isExtensionChoice } from './extensionChoice';

/** The question holds an answer of its own type (a comment alone is not one). */
export const hasReviewAnswer = (
  question: ReviewQuestion,
  answer?: ReviewAnswer
): boolean => {
  if (!answer) return false;
  switch (question.type) {
    case ReviewQuestionType.RATING:
      return answer.rating != null;
    case ReviewQuestionType.MULTIPLE_CHOICE:
      return !!answer.optionId;
    case ReviewQuestionType.GOALS:
      return !!answer.goals?.some((g) => !!g.comment?.trim());
    default:
      return !!answer.text?.trim();
  }
};

/**
 * The question still needs something before the review can be submitted: a
 * required answer, or the date of a probation decision answered "extend".
 * Mirrors the backend's submit checks (`cleanAnswers`), where a GOALS
 * question never blocks: its comments are optional.
 */
export const needsReviewAnswer = (
  question: ReviewQuestion,
  answer?: ReviewAnswer
): boolean => {
  if (isExtensionChoice(question, answer) && !answer?.date) return true;
  if (!question.required || question.type === ReviewQuestionType.GOALS) {
    return false;
  }
  return !hasReviewAnswer(question, answer);
};
